import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=not auth

  useEffect(() => {
    const t = localStorage.getItem("cd-token");
    if (!t) { setUser(null); return; }
    api.me().then(setUser).catch(() => { setToken(null); setUser(null); });
  }, []);

  const login = async (username, password) => {
    const { token, user } = await api.login(username, password);
    setToken(token);
    setUser(user);
    return user;
  };
  const logout = () => { setToken(null); setUser(null); window.location.href = "/login"; };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
